var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeonInmobiliariaIconsWaschmaschine = function SvgLeonInmobiliariaIconsWaschmaschine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "leon-inmobiliaria-icons-waschmaschine_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".leon-inmobiliaria-icons-waschmaschine_svg__st0{display:none}.leon-inmobiliaria-icons-waschmaschine_svg__st1{fill:currentcolor}.leon-inmobiliaria-icons-waschmaschine_svg__st1,.leon-inmobiliaria-icons-waschmaschine_svg__st2{display:inline}.leon-inmobiliaria-icons-waschmaschine_svg__st3{fill:currentcolor}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leon-inmobiliaria-icons-waschmaschine_svg__Waschmaschine"
  }, /*#__PURE__*/React.createElement("path", {
    className: "leon-inmobiliaria-icons-waschmaschine_svg__st3",
    d: "M11.7 10.6V90h76.7V10.6H11.7zm5.5 73.9V16.1h65.7v68.4H17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "leon-inmobiliaria-icons-waschmaschine_svg__st3",
    d: "M50 36c-11.4 0-20.7 9.3-20.7 20.7S38.6 77.4 50 77.4c11.4 0 20.7-9.3 20.7-20.7S61.4 36 50 36zm15.2 20.7C65.2 65.1 58.4 72 50 72s-15.3-6.8-15.3-15.3c0-8.4 6.8-15.2 15.2-15.2 8.5 0 15.3 6.8 15.3 15.2zM73.2 26.1c0-3-2.4-5.4-5.5-5.4-3 0-5.5 2.4-5.5 5.5s2.4 5.5 5.5 5.5c3 0 5.5-2.4 5.5-5.5"
  }))));
};
export default SvgLeonInmobiliariaIconsWaschmaschine;